import fetch from "auth/FetchInterceptor"

const DashboardService = {}

DashboardService.getStatistics = function () {
  return fetch({
    url: "/partner/statistics/all",
    method: "get",
  })
}

DashboardService.getChiffreAffaire = function () {
  return fetch({
    url: "/partner/statistics/chiffreAffaire/all",
    method: "get",
  })
}

DashboardService.getChiffreAffaireByPeriod = function (period) {
  return fetch({
    url: `/partner/statistics/chiffreAffaire/${period}`,
    method: "get",
  })
}

export default DashboardService
